export default __webpack_public_path__ + "static/media/cello-mobile.6759e77a.png";